<template>
  <div class="gradient text-white min-h-screen flex items-center">
    <div class="container mx-auto p-4 flex flex-wrap items-center">
      <div class="w-full md:w-5/12 text-center p-4">
        <img src="@/assets/images/404.png" />
      </div>
      <div class="w-full md:w-7/12 text-center md:text-left p-4">
        <div class="text-6xl font-medium">Page Not Found</div>
        <div class="text-6xl md:text-3xl font-medium mb-4">
          We looked everywhere for this page. Are you sure the website URL is correct?
        </div>
        <div class="text-lg mb-8">You may have mistyped the address or the page may have moved.</div>
        <a href="/" class="border border-white bg-je-tertiary-indicator rounded p-4">Go Home</a>
      </div>
    </div>
  </div>
</template>
<style>
.gradient {
  background-image: linear-gradient(190deg, #d6d1d3 25%, #2b3447 100%);
}
</style>
